'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _webComponents = require('@vezeeta/web-components');

var _enum = require('@vezeeta/enterprise-utils/lib/enum');

var _accounts = require('../actions/accounts');

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/*:: type State = {
  userBasicInfo: Function,
  userBasicInfoList: Map<String, Object>,
};*/


var initialState /*: State*/ = {
  userBasicInfo: _webComponents.renderer.loading(),
  userBasicInfoList: new Map(),
  userAccountsList: undefined,
  userAccountsListLoadState: _enum.status.SHOULD_CALL_API,
  addUserAccount: undefined,
  addUserAccountLoadState: _enum.status.SHOULD_CALL_API,
  editUserAccount: undefined,
  editUserAccountLoadState: _enum.status.SHOULD_CALL_API,
  updateLoginStatusLoadState: _enum.status.SHOULD_CALL_API,

  userAccountInfo: undefined,
  filterDropDown: { isOpened: false },
  addUserModal: { isOpened: false },
  editUserModal: { isOpened: false },
  aboutUserModal: { isOpened: false }
};

exports.default = function () {
  var state /*: State*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];

  var type = _ref.type,
      payload = _objectWithoutProperties(_ref, ['type']);

  switch (type) {
    case _accounts.ACCOUNTS.BASICINFO.LOADING:
      return _extends({}, state, {
        userBasicInfo: _webComponents.renderer.loading()
      });

    case _accounts.ACCOUNTS.BASICINFO.SUCCEEDED:
      {
        var _userBasicInfoList = state.userBasicInfoList;
        var accountKey = payload.accountKey,
            _userBasicInfo = payload.userBasicInfo;

        _userBasicInfoList.set(accountKey, {
          FirstName: _userBasicInfo.FirstName,
          LastName: _userBasicInfo.LastName,
          CountryCodeId: _userBasicInfo.CountryCodeId,
          PhoneNumber: _userBasicInfo.PhoneNumber,
          EmailAddress: _userBasicInfo.EmailAddress,
          GoogleId: _userBasicInfo.GoogleId,
          FacebookId: _userBasicInfo.FacebookId,
          CountryIsoCode: _userBasicInfo.CountryIsoCode,
          ProfilePhotoPath: _userBasicInfo.ProfilePhotoPath
        });

        return _extends({}, state, {
          userBasicInfo: _webComponents.renderer.success(_userBasicInfoList),
          userBasicInfoList: _userBasicInfoList
        });
      }

    case _accounts.ACCOUNTS.BASICINFO.FAILED:
      return _extends({}, state, {
        userBasicInfo: _webComponents.renderer.failure(payload.error)
      });
    case _accounts.ACCOUNTS.TOGGLE_FILTER_DROPDOWN:
      return _extends({}, state, { filterDropDown: { isOpened: payload.payload } });
    case _accounts.ACCOUNTS.TOGGLE_ADD_USER_MODAL:
      return _extends({}, state, { addUserModal: { isOpened: payload.payload } });
    case _accounts.ACCOUNTS.TOGGLE_EDIT_USER_MODAL:
      return _extends({}, state, { editUserModal: { isOpened: payload.payload } });
    case _accounts.ACCOUNTS.TOGGLE_ABOUT_USER_MODAL:
      return _extends({}, state, { aboutUserModal: { isOpened: payload.payload } });

    case _accounts.ACCOUNTS.SET_USER_ACCOUNT_INFO:
      return _extends({}, state, { userAccountInfo: payload.payload });
    case _accounts.ACCOUNTS.SEARCH_ACCOUNTS.LOADING:
      return _extends({}, state, { userAccountsListLoadState: _enum.status.FETCHING, userAccountsList: undefined });
    case _accounts.ACCOUNTS.SEARCH_ACCOUNTS.SUCCEEDED:
      {
        return _extends({}, state, {
          userAccountsListLoadState: _enum.status.SUCCESS,
          userAccountsList: payload.payload
        });
      }
    case _accounts.ACCOUNTS.SEARCH_ACCOUNTS.FAILED:
      return _extends({}, state, {
        userAccountsListLoadState: _enum.status.FAIL,
        userAccountsList: payload.payload
      });

    case _accounts.ACCOUNTS.Add_USER_ACCOUNT.LOADING:
      return _extends({}, state, { addUserAccountLoadState: _enum.status.SUBMITING });
    case _accounts.ACCOUNTS.Add_USER_ACCOUNT.SUCCEEDED:
      {
        return _extends({}, state, {
          addUserAccountLoadState: _enum.status.SUCCESS,
          addUserAccount: payload.payload
        });
      }
    case _accounts.ACCOUNTS.Add_USER_ACCOUNT.FAILED:
      return _extends({}, state, {
        addUserAccountLoadState: _enum.status.FAIL,
        addUserAccount: payload.payload
      });

    case _accounts.ACCOUNTS.EDIT_USER_ACCOUNTS.LOADING:
      return _extends({}, state, { editUserAccountLoadState: _enum.status.SUBMITING });
    case _accounts.ACCOUNTS.EDIT_USER_ACCOUNTS.SUCCEEDED:
      {
        return _extends({}, state, {
          editUserAccountLoadState: _enum.status.SUCCESS,
          editUserAccount: payload.payload
        });
      }
    case _accounts.ACCOUNTS.EDIT_USER_ACCOUNTS.FAILED:
      return _extends({}, state, {
        editUserAccountLoadState: _enum.status.FAIL,
        editUserAccount: payload.payload
      });

    case _accounts.ACCOUNTS.UPDATE_LOGIN_STATUS.LOADING:
      return _extends({}, state, { updateLoginStatusLoadState: _enum.status.SUBMITING });
    case _accounts.ACCOUNTS.UPDATE_LOGIN_STATUS.SUCCEEDED:
      {
        return _extends({}, state, {
          updateLoginStatusLoadState: _enum.status.SUCCESS
        });
      }
    case _accounts.ACCOUNTS.UPDATE_LOGIN_STATUS.FAILED:
      return _extends({}, state, {
        updateLoginStatusLoadState: _enum.status.FAIL
      });

    default:
      return state;
  }
};

module.exports = exports['default'];